var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "24px",
    viewBox: "0 0 31 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54DC7ADE-46A9-463F-BB22-6202C525CC3B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-T-P3",
    transform: "translate(-704.000000, -342.000000)",
    fill: "#929AA6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "therapist",
    transform: "translate(538.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-upload",
    transform: "translate(166.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5926551,11.8311067 C14.9643275,11.4616377 15.5645062,11.4616377 15.9361787,11.8311067 L15.9361787,11.8311067 L19.7475931,15.6425211 L18.4040695,16.9860447 L16.2220347,14.8040099 L16.2220347,23.9418759 L14.3163275,23.9418759 L14.3163275,14.8040099 L12.1247643,16.9860447 L10.7812407,15.6425211 Z M12.6896278,0.319801489 C18.3041985,-1.08958809 23.9981538,2.31936476 25.4075434,7.93393548 C28.386402,8.66161787 30.4853002,11.3266898 30.494622,14.3930918 C30.5057866,18.0768238 27.5285955,21.0721191 23.8448635,21.0833012 L23.8448635,21.0833012 L20.0334491,21.0833012 L20.0334491,19.1775484 L23.8448635,19.1775484 C26.2075831,19.1657568 28.2047643,17.4241191 28.5378462,15.0849826 C28.9087444,12.4800596 27.0977866,10.0676129 24.492804,9.69665509 C24.0871266,9.64281886 23.7611911,9.336 23.6828784,8.93437221 C22.8898065,4.9119603 19.3604963,2.01349876 15.2606055,2.01760794 C10.5243871,2.02231266 6.68873449,5.86564764 6.69349876,10.601866 C6.69349876,11.128139 6.26691811,11.5547196 5.74064516,11.5547196 C3.63567246,11.5547196 1.92923077,13.2611613 1.92923077,15.366134 C1.92923077,17.4711067 3.63567246,19.1775484 5.74064516,19.1775484 L5.74064516,19.1775484 L10.5049132,19.1775484 L10.5049132,21.0833012 L5.74064516,21.0833012 C2.93365757,21.0943921 0.533776675,19.0660645 0.0770620347,16.2964169 C-0.436704715,13.1810025 1.67237717,10.2390074 4.78779156,9.72524069 C5.11604963,5.21341935 8.30197519,1.42124069 12.6896278,0.319801489 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.48d57fe9a6b0aa5122f8fbd6cdd9c9cf.svg";
export { ForwardRef as ReactComponent };